// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseEnvironmentSpecComponent } from './ResponseEnvironmentSpecComponent';
import {
  ResponseEnvironmentSpecComponentFromJSON,
  ResponseEnvironmentSpecComponentFromJSONTyped,
  ResponseEnvironmentSpecComponentToJSON,
  ResponseEnvironmentSpecComponentToJSONTyped,
} from './ResponseEnvironmentSpecComponent';
import type { ResponseOwnerIdentifier } from './ResponseOwnerIdentifier';
import {
  ResponseOwnerIdentifierFromJSON,
  ResponseOwnerIdentifierFromJSONTyped,
  ResponseOwnerIdentifierToJSON,
  ResponseOwnerIdentifierToJSONTyped,
} from './ResponseOwnerIdentifier';
import type { ResponseEnvironmentSpecCluster } from './ResponseEnvironmentSpecCluster';
import {
  ResponseEnvironmentSpecClusterFromJSON,
  ResponseEnvironmentSpecClusterFromJSONTyped,
  ResponseEnvironmentSpecClusterToJSON,
  ResponseEnvironmentSpecClusterToJSONTyped,
} from './ResponseEnvironmentSpecCluster';

/**
 *
 * @export
 * @interface ResponseEnvironmentSpec
 */
export interface ResponseEnvironmentSpec {
  /**
   *
   * @type {Array<ResponseEnvironmentSpecCluster>}
   * @memberof ResponseEnvironmentSpec
   */
  clusters?: Array<ResponseEnvironmentSpecCluster>;
  /**
   *
   * @type {Array<ResponseEnvironmentSpecComponent>}
   * @memberof ResponseEnvironmentSpec
   */
  components?: Array<ResponseEnvironmentSpecComponent>;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentSpec
   */
  gcpProjectId?: string;
  /**
   *
   * @type {Array<ResponseOwnerIdentifier>}
   * @memberof ResponseEnvironmentSpec
   */
  ownerIdentifiers?: Array<ResponseOwnerIdentifier>;
}

/**
 * Check if a given object implements the ResponseEnvironmentSpec interface.
 */
export function instanceOfResponseEnvironmentSpec(
  value: object,
): value is ResponseEnvironmentSpec {
  return true;
}

export function ResponseEnvironmentSpecFromJSON(
  json: any,
): ResponseEnvironmentSpec {
  return ResponseEnvironmentSpecFromJSONTyped(json, false);
}

export function ResponseEnvironmentSpecFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseEnvironmentSpec {
  if (json == null) {
    return json;
  }
  return {
    clusters:
      json['clusters'] == null
        ? undefined
        : (json['clusters'] as Array<any>).map(
            ResponseEnvironmentSpecClusterFromJSON,
          ),
    components:
      json['components'] == null
        ? undefined
        : (json['components'] as Array<any>).map(
            ResponseEnvironmentSpecComponentFromJSON,
          ),
    gcpProjectId:
      json['gcp_project_id'] == null ? undefined : json['gcp_project_id'],
    ownerIdentifiers:
      json['owner_identifiers'] == null
        ? undefined
        : (json['owner_identifiers'] as Array<any>).map(
            ResponseOwnerIdentifierFromJSON,
          ),
  };
}

export function ResponseEnvironmentSpecToJSON(
  json: any,
): ResponseEnvironmentSpec {
  return ResponseEnvironmentSpecToJSONTyped(json, false);
}

export function ResponseEnvironmentSpecToJSONTyped(
  value?: ResponseEnvironmentSpec | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    clusters:
      value['clusters'] == null
        ? undefined
        : (value['clusters'] as Array<any>).map(
            ResponseEnvironmentSpecClusterToJSON,
          ),
    components:
      value['components'] == null
        ? undefined
        : (value['components'] as Array<any>).map(
            ResponseEnvironmentSpecComponentToJSON,
          ),
    gcp_project_id: value['gcpProjectId'],
    owner_identifiers:
      value['ownerIdentifiers'] == null
        ? undefined
        : (value['ownerIdentifiers'] as Array<any>).map(
            ResponseOwnerIdentifierToJSON,
          ),
  };
}
